





























import { Button } from 'element-ui'
import { Component, Vue, Prop } from 'vue-property-decorator'

import Customer from '@/models/customer'

@Component({
  components: {
    [Button.name]: Button,
  },
})
export default class ProfileInfo extends Vue {
  @Prop() customer!: Customer
}
